<template>
  <v-app id="app" ref="app">
    <!-- headerナビゲーション -->
    <v-navbar-top v-if="isAuthenticated"/>

    <!-- leftナビゲーション -->
    <div @click.stop="" v-if="isAuthenticated">
      <v-navbar-left class="navigation-drawer"></v-navbar-left>
    </div>

    <!-- loading -->
    <v-loading ref="loading"/>

    <v-main>
      <v-container fluid class="px-16 signin-background">
        <router-view class="ml-2"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import VNavbarTop from '@/components/organizms/NavbarTop'
  import VNavbarLeft from '@/components/organizms/NavbarLeft'
  import VLoading from '@/components/organizms/Loading'

  export default {
    components: {
      VNavbarTop,
      VNavbarLeft,
      VLoading
    },

    computed: {
      isAuthenticated() {
        return !!this.$store.state.user.accessToken
      },
      drawer() {
        return this.$store.state.drawer;
      },
      isDevMode() {
        return process.env.NODE_ENV === 'development'
      }
    },

    methods: {
      // ipadで見たときに、ブラウザ上部のバーによって高さがずれるため調整
      setViewHeight() {
        this.$refs.app.$el.style['min-height'] = window.innerHeight + 'px'
      },
    },

    mounted() {
      //リサイズする度に高さ再調整
      window.addEventListener("resize", this.setViewHeight);
      this.setViewHeight()
      // タブ名を設定
      document.title = '新学社テスト作成システム';
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.setViewHeight);
    },
  }
</script>

<style lang="stylus">
.signin-background
  height 100%
  background-image: linear-gradient(to bottom, #e5e5e5, #ddd, #f0f0f0)
  background-size: cover;
  position: relative;
  z-index: 0;
  overflow: hidden;

.signin-background:before
  content: '';
  background: inherit;
  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -o-filter: blur(10px);
  -ms-filter: blur(10px);
  filter: blur(40px);
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  z-index: -1;

.header-logo
  margin: 0px;
  margin-bottom: 5px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

.navigation-drawer
  height: calc(100% - 72px)!important;
  margin-top 72px;

.v-data-table
  white-space nowrap
</style>
